import { render, staticRenderFns } from "./QualityControlDialog.vue?vue&type=template&id=1f825c96"
import script from "./QualityControlDialog.vue?vue&type=script&lang=js"
export * from "./QualityControlDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports